import { useState, useEffect } from 'react';
import { useAppContext } from '../../context/AppContext';

export default function IngredientManager({ onSelect, selectedIngredients = [] }) {
    const { ingredients = [], addIngredient, deleteIngredient } = useAppContext();
    const [showForm, setShowForm] = useState(false);
    const [name, setName] = useState('');
    const [unit, setUnit] = useState('kg');
    const [costPerUnit, setCostPerUnit] = useState('');
    const [saving, setSaving] = useState(false);

    const handleAddIngredient = async (e) => {
        e.preventDefault();
        if (!name.trim() || !costPerUnit) return;

        try {
            setSaving(true);
            await addIngredient({
                name: name.trim(),
                unit,
                costPerUnit: Number(costPerUnit)
            });
            setName('');
            setCostPerUnit('');
            setUnit('kg');
            setShowForm(false);
        } catch (err) {
            alert('Erro ao adicionar matéria-prima');
        } finally {
            setSaving(false);
        }
    };

    const handleSelectIngredient = (ingredient) => {
        if (onSelect) {
            onSelect(ingredient);
        }
    };

    const handleDeleteIngredient = async (id, name) => {
        if (window.confirm(`Excluir matéria-prima "${name}"?`)) {
            try {
                await deleteIngredient(id);
            } catch (err) {
                alert('Erro ao excluir');
            }
        }
    };

    return (
        <div className="ingredient-manager">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="mb-0">Matérias-Primas</h6>
                <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => setShowForm(!showForm)}
                >
                    {showForm ? 'Cancelar' : '+ Nova Matéria-Prima'}
                </button>
            </div>

            {showForm && (
                <form onSubmit={handleAddIngredient} className="mb-3 p-3 bg-light rounded">
                    <div className="row g-2">
                        <div className="col-12">
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Nome (ex: Farinha de trigo)"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                            />
                        </div>
                        <div className="col-6">
                            <select
                                className="form-select form-select-sm"
                                value={unit}
                                onChange={(e) => setUnit(e.target.value)}
                            >
                                <option value="kg">Quilograma (kg)</option>
                                <option value="g">Grama (g)</option>
                                <option value="l">Litro (L)</option>
                                <option value="ml">Mililitro (mL)</option>
                                <option value="un">Unidade</option>
                            </select>
                        </div>
                        <div className="col-6">
                            <div className="input-group input-group-sm">
                                <span className="input-group-text">R$</span>
                                <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    className="form-control"
                                    placeholder="Custo"
                                    value={costPerUnit}
                                    onChange={(e) => setCostPerUnit(e.target.value)}
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-12">
                            <button type="submit" className="btn btn-sm btn-primary w-100" disabled={saving}>
                                {saving ? 'Salvando...' : 'Adicionar'}
                            </button>
                        </div>
                    </div>
                </form>
            )}

            {ingredients.length === 0 ? (
                <div className="alert alert-info small mb-0">
                    Nenhuma matéria-prima cadastrada. Adicione suas matérias-primas para facilitar o cálculo de custos.
                </div>
            ) : (
                <div className="list-group list-group-flush" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                    {ingredients.map((ing) => {
                        const isSelected = selectedIngredients.some(si => si.id === ing.id);
                        return (
                            <div
                                key={ing.id}
                                className={`list-group-item d-flex justify-content-between align-items-center ${isSelected ? 'bg-primary bg-opacity-10' : ''}`}
                            >
                                <div className="flex-grow-1" role="button" onClick={() => handleSelectIngredient(ing)}>
                                    <div className="fw-semibold small">{ing.name}</div>
                                    <div className="text-muted small">
                                        R$ {ing.costPerUnit.toFixed(2)} / {ing.unit}
                                    </div>
                                </div>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleDeleteIngredient(ing.id, ing.name);
                                    }}
                                    title="Excluir"
                                >
                                    <i className="bi bi-trash"></i>
                                </button>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
